export default "__VITE_ASSET__CMzF_E41__"